@if (!inactiveMemberForSubscription) {
  <div>
    <span>
      Tous les dentistes inscrit au Tableau de l'Ordre doivent souscrire au Fonds, à moins d'en être dispensé par l'Ordre.
      <br><br>
      <u><strong>IMPORTANT</strong></u>
      <br>
        La souscription doit être acquittée au plus tard le <strong>{{model?.period?.effectiveStartDate  | date: 'yyyy/MM/dd'}} à 0h01 heure normale de l'est.</strong>
        <br><br>
        <u><strong>Aucun délai ne sera accordé</strong></u>
        <br>
          Sur réception de votre paiement, une preuve d'assurance vous sera acheminée.
        </span>
        <br><br>
        <span>
          SOUSCRIPTION OBLIGATOIRE POUR LA PÉRIODE DU <strong>{{model?.period?.effectiveStartDate | date: 'yyyy/MM/dd'}}</strong> AU <strong>{{ model?.period?.effectiveEndDate | date: 'yyyy/MM/dd'}} à 0h01 heure normale de l'est. </strong>
        </span>
        <br><br>
        <p>
          Le Fonds d’assurance-responsabilité professionnelle de l’Ordre des dentistes du Québec (Fonds) offre à ses assurés une assurance de base prévoyant une limite
          par sinistre de 2 000 000 $ et une limite par période d’assurance de 4 000 000 $.
        </p>
      </div>
    }
    @if (inactiveMemberForSubscription) {
      <div>
        <br>
          <span>
            <p>
              Selon le Règlement sur l'assurance de la responsabilité professionnelle des membres de l'Ordre des dentistes du Québec, le dentiste inscrit au Tableau
              de l'Ordre doit souscrire au Fonds à moins d'en être dispensé par l'Ordre. Suivant votre changement de statut,
              et considérant la clause 5.05 – Prolongation du contrat cadre, votre garantie de base restera en vigueur indéfiniment et sans coût additionnel
              tant que le Fonds existera, mais elle ne s’appliquera qu’aux seuls Services professionnels rendus avant le décès, la radiation, la cessation
              d’exercice ou le moment de l’exemption, selon le contrat en vigueur lorsque la Réclamation est présentée.
            </p>
            <p>
              La limite de garantie par Sinistre applicable au cours de la période de prolongation correspond à la limite d’assurance minimale obligatoire décrite par le Règlement
              sur l’assurance de la responsabilité professionnelle des membres de l’Ordre des dentistes du Québec, soit 2 000 000$.
            </p>
            <p>
              En fonction de vos souscriptions antérieures, vous pouvez souscrire, sur une base annuelle, une tranche d’assurance excédentaire. Vous devez alors acquitter la prime afférente.
            </p>
            <p>
              Veuillez sélectionner la limite d’assurance excédentaire souhaitée.
            </p>
            <p>
              Le prix indiqué dans ce tableau correspond au total de la prime que vous aurez à verser pour la prime d’assurance excédentaire et toute surprime
              qui pourrait être liée à votre historique de sinistre, le cas échéant, pour la période de couverture souscrite.
            </p>
            <p class="font-italic">
              *Les dentistes qui pratiquent en société peuvent être tenus de souscrire une protection additionnelle aux 2 000 000$ de base. Si tel est le cas,
              la limite de couverture minimale pour votre situation est indiquée dans la section précédente « assurance obligatoire de base ».
            </p>
            <u><strong>IMPORTANT</strong></u>
            <br>
              La souscription doit être acquittée au plus tard le <strong>{{model?.period?.effectiveStartDate  | date: 'yyyy/MM/dd'}} à 0h01 heure normale de l'est.</strong>.
              <br><br>
              <u><strong>Aucun délai ne sera accordé</strong></u>
              <br>
                Sur réception de votre paiement, une preuve d'assurance vous sera acheminée.
              </span>
              <br><br>
              <span>
                SOUSCRIPTION OBLIGATOIRE POUR LA PÉRIODE DU <strong>{{model?.period?.effectiveStartDate | date: 'yyyy/MM/dd'}}</strong> AU <strong>{{ model?.period?.effectiveEndDate | date: 'yyyy/MM/dd'}} à 0h01 heure normale de l'est.</strong>
              </span>
              <br>
              </div>
            }


